export const openPopup = ({ wixCodeApi })=>(popupId, data)=>{
        // openLightboxById resolves only when the popup is closed, not when it opens.
        // Awaiting it would keep the form's inProgress state true until the user closes
        // the popup, causing the submit button to show a loader the entire time.
        void wixCodeApi.window.openLightboxById(popupId, data);
        return Promise.resolve();
    };

//# sourceMappingURL=open-popup.js.map